import {SET_CARDS, REPLACE_CARD, ADD_CARD, ADD_CARDS} from 'actions/types';


var cardsInitialState = {
        cardsList:[], 
        isCardsListLoaded:false, 
        indexed:{}
    };
export default (state = cardsInitialState, action) => {
    switch(action.type) {
        case SET_CARDS: 
            return {...state,
                    cardsList:action.cards.map((c)=>(c.id)),
                    indexed:action.cards.reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed}),
                    isCardsListLoaded:true
                    };
        case REPLACE_CARD: 
            return {...state,
                    cardsList:state.cardsList.map(id=>(id===action.oldCard.id ? action.card.id : id )),
                    indexed: {...state.indexed, [action.card.id]:action.card}
                    };
        case ADD_CARD: 
            return {...state,
                    indexed: {...state.indexed, [action.card.id]:action.card}
                    };
        case ADD_CARDS: 
            return {...state,
                    indexed:action.cards.reduce((m,c)=>{m[c.id]=c;return m;},{...state.indexed}),
                    };
        default:            
            return state;
    }
}

//selectors
export const isCardsListLoaded  = state => state.isCardsListLoaded;
export const isDailyListLoaded  = state => state.isDailyListLoaded;
export const getCards = state => state.cardsList.map( id => state.indexed[id] );
export const getCard  = (state, id) => state.indexed[id];



// WEBPACK FOOTER //
// ./src/reducers/cards.js